export const servicesTranslations = {
    // Services Page
    services_screen_title: "Managed Testing Services",
    services_screen_description: "Comprehensive quality assurance solutions to ensure your software exceeds expectations.",
    services_consult_button: "Request a Consultation",
    services_learnMore: "Learn More",
    services_screen_discussProject: "Let's Discuss Your Project",
    services_screen_contactDescription: "Contact us to learn how Quality Nexus can help ensure the quality of your software products.",
    // Service Details Page
    service_details_ourProcess: "Our Process",
    service_details_whatWeDoBest: "What we do best",
    service_details_readyToStart: "Ready to get started?",
    service_details_contactUs: "Contact us to learn how Quality Nexus can help with your",
    service_details_needs: "needs.",
    service_details_getInTouch: "Get In Touch",
    // Services Data
    services_labels: {
      basic: "Basic",
      advanced: "Advanced",
      premium: "Premium"

    },
    // Contact Form - Services Screen
    services_contact_title: "Let's Discuss Your Project",
    services_contact_description: "Contact us to learn how Quality Nexus can help ensure the quality of your software products.",
    services_contact_form: {
        full_name_label: "Full Name",
        full_name_placeholder: "Your Name",
        email_label: "Email",
        email_placeholder: "your.email@example.com",
        company_label: "Company",
        company_placeholder: "Your company name",
        services_label: "Interested Service",
        services_placeholder: "Select a service",
        message_label: "Message",
        message_placeholder: "Tell us about your project and testing needs",
        submit_button: "Send Request",
        loading: "Submitting...",
  slack_message_intro: "A new service inquiry is submitted."
    },
    form_submit_success: "Your message has been sent successfully.",
    form_submit_error: "Something went wrong. Please try again.",
    // Crowd Testing Coming Soon
    coming_soon: "Coming Soon",
    crowd_testing_coming_soon_description: "We're developing comprehensive crowd testing services. Stay tuned for updates!"
}